import { createFileRoute, redirect } from "@tanstack/react-router";

// The MCP setup guide lives on /ai-access (single, public source of truth).
export const Route = createFileRoute("/docs/mcp")({
  beforeLoad: () => {
    throw redirect({ to: "/ai-access", statusCode: 301 });
  },
});
